import { useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import SearchBox from "../components/SearchComponent";
import { BsBoxSeam } from "react-icons/bs";
import { LuBuilding2 } from "react-icons/lu";
import { RiTruckLine } from "react-icons/ri";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { csvUrls, headerColumn } from "../../constants";
import DropZone from "./components/DropZone";
import FooterSection from "./components/FooterSection";
import SearchableDropdown from "../../Common/SearchDropdown";
import "./importData.css";

const tabs = [
    { name: "Companies", icon: <LuBuilding2 fontSize={20} />, headers: headerColumn.imports.companies },
    { name: "Inventory", icon: <BsBoxSeam fontSize={20} />, headers: headerColumn.imports.companies },
    { name: "Vehicle & GPS Devices", icon: <RiTruckLine fontSize={24} />, headers: headerColumn.imports.companies }
]

const ImportData = () => {
    const [state, setState] = useState({
        search: "",
        activeTab: tabs[0],
        errorFileds: {},
        csvFileName: "",
        type: "GPS",
        typeId: 20,
        error: false,
        uploadKey: 0
    });
    const [csvUrl, setCsvUrl] = useState(csvUrls.import["companies"]);

    const { filters } = useSelector(({ inventory }) => ({
        filters: inventory.filters
    }), shallowEqual);
    const { search, activeTab, error, errorFileds, type, typeId, uploadKey } = state;
    const inventoryType = typeId == 20 ? 2 : typeId == 21 ? 3 : 1;

    const changeTab = (tab, activeIndex) => {
        const active = tab?.name == "Companies" ? "companies" : tab?.name == "Inventory" ? "inventories" : "vehicles";
        let value = csvUrls.import[active];
        if(tab?.name == "Inventory") {
            let invType = inventoryType;
            if(activeIndex) invType = activeIndex == 20 ? 2 : activeIndex == 21 ? 3 : 1;
            value = value[invType];
        }
        setCsvUrl(value);
        if(!activeIndex) setState(prev => ({ ...prev, activeTab: tab, errorFileds: {}, error: false, uploadKey: Math.random() }))
    }

    const setError = (errors) => {
        setState(prev => ({...prev, error: errors?.length > 0 ? true: false, errorFileds: errors || [], uploadKey: Math.random() }))
    }

    const onSelectHandler = (event) =>{
       const { value, name } = event.target;
       setState(prev => ({ ...prev, [name]: value?.name ?? "", [`${name}Id`]: value?.id ?? "" }));
       setTimeout(() => changeTab(activeTab, value?.id), 200)
    }

    return <div className="import-container">
        {/* <SearchBox placeholder="Search here..." className="mb-3" value={search} onChange={(e) => setState(prev => ({ ...prev, search: e.target.value }))} /> */}
        <div className="table-section">
            <div className="row mb-2">
                <div className={`table-title col-12`}>
                    <h4>Import Data</h4>
                </div>
            </div>

            <div className="tabs p-1 rounded d-md-flex justify-content-between text-center">
                {tabs.map((tab, index) => <div className={`d-flex justify-content-center align-items-center rounded py-2 flex-fill ${activeTab.name == tab.name ? "active" : ""} mx-1`} key={index} onClick={() => changeTab(tab)}><span>{tab.icon}</span><div className="ms-2">{tab.name}</div>
                </div>)}
            </div>

            <div className="uploader-section pt-3 px-2">
                <div className="title-section d-flex align-items-center mt-4">
                    <span>{activeTab.icon}</span>
                    <p className="ms-2 mb-0">{`Import ${activeTab.name}`}</p>
                </div>

                <div className="mt-3">
                    {activeTab.name == "Inventory" ? <div className={`col-lg-6`}>
                        <SearchableDropdown
                            label={"Inventory Type"}
                            placeholder={"Select Inventory Type"}
                            value={type}
                            options={filters?.inventoryTypes ?? []}
                            onSelect={(value) => onSelectHandler({ target: { name: "type", value } })}
                        />
                    </div> : null}
                    
                    <DropZone key={uploadKey} url={csvUrl} fileName={activeTab.name == "Companies" ? "companies" : activeTab.name == "Inventory" ? `inventories-${inventoryType == 3 ? "sim" : inventoryType == 2 ? "gps" : "gps_with_Sim"}` : "vehicle-gps"} inventoryTypeId={typeId} setError={(errRes) => setError(errRes?.data?.errors || [])} />

                    <FooterSection errorFileds={errorFileds} />
                </div>
            </div>
        </div>
        {error ? <div className="bg-white py-3 px-2 my-2 rounded">
            <div className="text-danger rounded p-2 d-flex justify-content-start align-items-md-center" style={{ backgroundColor: "#F7DEDE" }}>
                <IoMdInformationCircleOutline className="mt-md-0 mt-2" fontSize={20} />
                <p className="mb-0 ms-2">Please fix all the error before importing the data</p>
            </div>
        </div> : null}
    </div>
}

export default ImportData;